export default (aa)=>{
    if(aa){
      let subaa=aa.substring(0,aa.indexOf('T'))
      return subaa
    }else{
      return aa
    }
  }



// WEBPACK FOOTER //
// ./src/filter/toTime.js